import { registerPlugin } from '@capacitor/core';
const NativeShare = registerPlugin('NativeShare', {
    web: () => import('./web').then((m) => new m.NativeShareWeb()),
});
export * from './definitions';
export { NativeShare };
//# sourceMappingURL=index.js.map